import $ from 'jquery';
(function(){
	'use strict';
	
    //Add comma seperator
    // function numberWithCommas(x) {
	//     return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
	// }

	//Calculate Electricity used2 (kWh)
    function calculateElectricityUsed(power, summer_use, winter_use) {
	    var result = Math.round(power/1000 * ( summer_use * 365/2 + winter_use * 365/2));
	    return result;
	}

	//Calculate Cost of electricity2,3
	function calculateCostOfElectricity(electricity_used, domestic_rate) {
	    var result = (electricity_used * domestic_rate/100).toFixed(2);
	    return result;
	}

	//Calculate Annual Savings
	function calculateAnnualSavings(electricity_cost, electricity_used, controlled_rate) {
	    var result = (electricity_cost - (electricity_used * controlled_rate/100)).toFixed(2);
	    return result;
	}

	$(".pool-calculator__wrapper").find('.sq-form-submit').on('click', function (event) {
	
		let entireForm = document.getElementsByClassName('pool-calculator__wrapper')[0].querySelector('form');
		let isFormValid = entireForm.checkValidity(entireForm);

		if (isFormValid) {
			event.preventDefault();

			// remove any existing validation errors
			$('.ee-form').find('.sq-form-error').siblings('.error-input').removeClass('error-input');
			$('.ee-form').find('.sq-form-error').remove();
			
			//get all user input
			var power = $('.poolpump_input-power').val();
			var summer_use = $('.poolpump_summer-hours').val();
			var winter_use = $('.poolpump_winter-hours').val();
			var domestic_rate = $('.poolpump_elect-rate--Domestic').val();
			var controlled_rate = $('.poolpump_elect-rate--CL2').val();

			// custom validation

			 var checkOnlyDigits = function (string) {
                return /^(?=.)([+-]?([0-9]*)(\.([0-9]+))?)$/.test(string);
            }

			var errorMessage  = `<p class="sq-form-error">This value must be a number.</p>`

			
			if (!checkOnlyDigits(domestic_rate)) {
				$('.poolpump_elect-rate--Domestic').addClass('error-input');
				$('.poolpump_elect-rate--Domestic').parent().append(errorMessage);
			}

			if (!checkOnlyDigits(controlled_rate)) {
				$('.poolpump_elect-rate--CL2').addClass('error-input');
				$('.poolpump_elect-rate--CL2').parent().append(errorMessage);
			}

			// do not allow calculations if either value contains characters
			if (!checkOnlyDigits(domestic_rate) || !checkOnlyDigits(controlled_rate)) {
				return;
			}
	  
			var electricity_used = calculateElectricityUsed(power, summer_use, winter_use);
			$('.pool-calculator_usage').html(electricity_used);
	  
			var electricity_cost = calculateCostOfElectricity(electricity_used, domestic_rate);
			$(".pool-calculator_cost").html(electricity_cost);
			
	  
			var annual_savings = calculateAnnualSavings(electricity_cost, electricity_used, controlled_rate);
			$(".pool-calculator_savings-value").html(annual_savings);
	  
			//Display all the results
			$(".calculator_results").slideDown();

			$('html, body').animate({
				scrollTop: $("#calculator-results").offset().top
			}, 800);
		}
	});
	
	// Submit arrow
}());
